'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _businessDetails = require('./business-details.html');

var _businessDetails2 = _interopRequireDefault(_businessDetails);

var _businessDetails3 = require('./business-details.controller');

var _businessDetails4 = _interopRequireDefault(_businessDetails3);

require('./business-details.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var businessDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template: _businessDetails2.default,
  controller: _businessDetails4.default,
  controllerAs: 'vm'
};

exports.default = businessDetailsComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/business-details/business-details.component.js
 **/